import { render, staticRenderFns } from "./Hires.vue?vue&type=template&id=4b9e0da2"
import script from "./Hires.vue?vue&type=script&lang=js"
export * from "./Hires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports